module.exports = __webpack_public_path__ + "img/1-19.c2e70a0a.jpg";